import react from "react";
import uRLs from "../../../utils/baseUtils";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { XIcon } from "../../../constants/Icons";

const ReportView = ({ onClose, viewData }) => {
  // console.log("viewData", viewData);
  const handleClose = () => {
    onClose();
  };

  const fetchTrackMode = (trackMode) => {
    switch (trackMode?.toUpperCase()) {
      case "JOBCARD":
        return "Jobcard";
      case "PAYLATER":
        return "Paylater";
      default:
        return trackMode;
    }
  };

  const saleDate = viewData?.saledate;
  const timezone = "Asia/kolkata";
  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const paymentMode = (mode) => {
    switch (mode.toUpperCase()) {
      case "ONLINE":
        return "Online";
      case "CASH":
        return "Cash";
      case "CARD":
        return "Card";
      case "UPI":
        return "UPI";
      default:
        return mode;
    }
  };

  return (
    <>
      <div>
        <div className="modal-backdrop show"></div>
        <div
          className="modal show"
          id="CustomerModal"
          tabIndex="-1"
          aria-modal="true"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-scrollable  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="d-flex align-items-center">
                  <h6 className="modal-title">{viewData?.salemode}</h6>
                </div>
                <div className="d-flex align-items-center  gap-2">
                  <p className="small mb-0 ">
                    <b className="tm_primary_color"> Created On:</b>{" "}
                    {saleTime.date} {""}
                    {saleTime.time}
                  </p>
                  <button
                    type="button"
                    onClick={handleClose}
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
              </div>
              <div className="modal-body" id="element-to-download">
                <div className="tm_container">
                  <div className="tm_invoice_wrap">
                    <div className="tm_invoice tm_style1 tm_type1">
                      <div className="tm_invoice_in">
                        <table width="100%" className="pdfcontent">
                          <tbody>
                            <tr>
                              <td width="50%" style={{ textAlign: "left" }}>
                                <div className="tm_logo">
                                  {viewData?.customerInfo?.image && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        "profile/" +
                                        viewData?.customerInfo?.image
                                      }
                                      className="img-rounded logo mb-0"
                                      height="50"
                                    />
                                  )}
                                </div>
                              </td>
                              <td width="50%" style={{ textAlign: "right" }}>
                                <div className="tm_primary_color fs-4 tm_text_uppercase">
                                  {viewData?.salemode &&
                                    formatTrackMode(viewData?.salemode)}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="tm_invoice_info tm_mb20">
                          <div className="tm_invoice_seperator tm_gray_bg"></div>
                          <div className="tm_invoice_info_list">
                            <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                              <b className="tm_primary_color">Sale No: </b>{" "}
                              {viewData.saleno}
                            </p>
                            <p className="tm_invoice_date tm_m0 mt-3">
                              <b className="tm_primary_color"> Date: </b>{" "}
                              {saleTime.date}
                            </p>
                          </div>
                        </div>
                        <table width="100%" className="pdfcontent">
                          <tbody>
                            <tr>
                              <td width="35%" style={{ verticalAlign: "top" }}>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    fontWeight: "600",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Sale By:
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Name :{viewData.saleby?.storename || ""}
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Type: {viewData.saleby?.storetype || ""}
                                </div>
                              </td>

                              <td width="10%"></td>
                              <td width="55%" style={{ verticalAlign: "top" }}>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    fontWeight: "600",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Sale To:
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Name :{viewData.saleto?.customername || "-"}
                                </div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    marginBottom: "0px",
                                  }}
                                >
                                  phone: {viewData.saleto?.customerphone || "-"}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          className="items"
                          width="100%"
                          style={{
                            marginTop: "6px",
                            borderCollapse: "collapse",
                          }}
                          cellPadding="4"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: "20px",
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                S.No
                              </th>
                              <th
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                MRP
                              </th>
                              <th
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                Discount
                              </th>
                              <th
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                Sale Price
                              </th>
                              <th
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                GST
                              </th>
                              <th
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  background: "#f3f3f3",
                                  border: "0.5mm solid #e0e0e0",
                                }}
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                1
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {CurrencyConverter.toCurrency(
                                  viewData?.totalMrp || 0,
                                  "INR"
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {CurrencyConverter.toCurrency(
                                  viewData?.totalDiscount || 0,
                                  "INR"
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {CurrencyConverter.toCurrency(
                                  viewData?.totalSalePrice || 0,
                                  "INR"
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {CurrencyConverter.toCurrency(
                                  viewData?.taxamount || 0,
                                  "INR"
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {CurrencyConverter.toCurrency(
                                  viewData?.totalamount || 0,
                                  "INR"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-block">
                <button
                  onClick={handleClose}
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-outline-secondary text-left"
                >
                  <XIcon iClass={"fs-15"}/> Close
                </button>
                <div className="btn-group text-right align-items-center">
                  {/* {print ? (
                      <button className="btn btn-warning btn-sm pb-0" disabled>
                        <CircularProgress size={18} className="text-black" />
                      </button>
                    ) : ( */}
                  <>
                    {/* <button
                      type="button"
                      className="btn bg-label-animal shadow-none btn-sm dropdown-toggle dropdown-toggle-split"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ borderRight: "2px solid #fff" }}
                    />

                    <button
                      //   onClick={() => handlePrint(data)}
                      className="btn bg-label-animal shadow-none btn-sm rounded-end"
                      id="printreceiptbtn"
                    >
                      <i className="bx bx-printer fs-15"></i> Print{" "}
                      {selectedSize}
                    </button> */}

                    {/* <ul className="dropdown-menu dropdown-menu-end">
                          {sizeOptions.map((opt) => (
                            <li key={opt.key}>
                              <button
                                className={`dropdown-item ${
                                  selectedSize === opt.key ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedSize(opt.key);
                                  updatePrinterSetting(opt.key); 
                                }}
                              >
                                {opt.label}
                              </button>
                            </li>
                          ))}
                        </ul> */}
                  </>
                  {/* )} */}
                </div>
                {/* 
                  {download ? (
                    <button
                      className="btn btn-warning btn-sm pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={18} className="text-black" />
                    </button>
                  ) : ( */}
                {/* <button
                  className="btn btn-warning btn-sm text-right"
                  id="generatebillpdfbtn"
                  //   onClick={() => handleDownload(data)}
                >
                  <i className="bx bx-download fs-15"></i>
                </button> */}
                {/* )} */}
                {/* {shareLoad ? (
                    <button
                      className="btn btn-success btn-sm pb-0 text-right"
                      disabled
                    >
                      <CircularProgress size={18} className="text-black" />
                    </button>
                  ) : ( */}
                {/* <button
                  className="btn btn-success btn-sm text-right"
                  id="generatebillpdfbtn"
                  //   onClick={() => handleWhappShare(data)}
                >
                  <i className="bx bxl-whatsapp fs-20"></i>
                </button> */}
                {/* )} */}
                {/* {data.status !== "CANCELLED" &&
                    (edit ? (
                      <button
                        className="btn btn-warning pb-0 text-right"
                        disabled
                      >
                        <CircularProgress size={18} className="text-black" />
                      </button>
                    ) : ( */}
                {/* <button
                  className="btn btn-label-primary pb-0 text-right"
                  // onClick={() => handleEdit(data)}
                >
                  <i className="ng ng-ng-edit-icon fs-15"></i>
                </button> */}
                {/* ))} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportView;
